module.exports = __webpack_public_path__ + "static/media/replace-vehicle.07e9c35a.svg";